import Link from '@mui/icons-material/Link';
import { Box, Input, styled, Fab, Stack, Grid } from '@mui/material';
import { WsButton, WsColors, WsTypography, WsTypoVariants } from 'wisestep-base';

const LinkFab = styled(Fab)({
  background: WsColors.TheBlues100,
  boxShadow: 'none',
  minWidth: 0,
  width: 0,
  minHeight: 0,
  height: 0,
  padding: 16,
});

const LinkInput = styled(Input)({
  borderWidth: 1,
  borderStyle: 'solid',
  borderColor: WsColors.TheBlues500,
  borderRadius: 4,
  paddingTop: 3,
  paddingBottom: 3,
  paddingLeft: 8,
  color: WsColors.TheBlues500,
});

const InviteLinkForm = () => (
  <Box bgcolor={WsColors.White} borderRadius={1.5} padding={2}>
    <Stack direction={'row'} alignItems={'center'} spacing={2}>
      <LinkFab>
        <Link sx={{ transform: 'rotateZ(-45deg)', fill: '#00B4D8' }} height="13.24px" />
      </LinkFab>
      <WsTypography variant={WsTypoVariants.BODY2}>Share a link</WsTypography>
    </Stack>
    <Box pl={6}>
      <WsTypography variant={WsTypoVariants.BODY2}>
        Anyone with this link will be assigned Recruiter with download access Allowed
      </WsTypography>
      <Stack direction={'row'} spacing={1} alignItems={'center'} my={2}>
        <Grid item xs={10}>
          <LinkInput
            fullWidth
            disableUnderline
            readOnly
            defaultValue={'https://s.muz.li/OGRlODcwNmI0' + ' (Coming soon)'}
            disabled
          />
        </Grid>
        <Grid item xs={2}>
          <WsButton variant="outlined" size="large" disabled>
            Copy Link
          </WsButton>
        </Grid>
      </Stack>
    </Box>
  </Box>
);

export default InviteLinkForm;
